import React from 'react';
import cn from 'classnames';

import LoadingIcon from '../../../../assets/icons/common/LoadingIcon';

import styles from './styles.module.scss';

/**
 * @param {colorType}
 * @type {string}
 * @values { orange | grey }
 */

const Button = ({
  children,
  className,
  type = 'button',
  colorType = 'orange',
  size = 'default',
  isLoading = false,
  ...props
}) => {
  return (
    <button
      className={cn(styles.button, styles[colorType], styles[size], className, {
        [styles.buttonLoading]: isLoading,
      })}
      type={type}
      disabled={isLoading}
      {...props}
    >
      {children}
      {isLoading && (
        <LoadingIcon className={styles.buttonLoadingIcon}></LoadingIcon>
      )}
    </button>
  );
};

export default Button;
